import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Marketplace from "@/pages/Marketplace";
import Transactions from "@/pages/Transactions";
import Profile from "@/pages/Profile";
import Rewards from "@/pages/Rewards";
import Admin from "@/pages/Admin";
import AdminRoute from "@/components/AdminRoute";

const withLayout = (el) => (
  <ProtectedRoute>
    <AppLayout>{el}</AppLayout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <div className="grain" />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/app" element={withLayout(<Dashboard />)} />
            <Route path="/app/marketplace" element={withLayout(<Marketplace />)} />
            <Route path="/app/rewards" element={withLayout(<Rewards />)} />
            <Route path="/app/transactions" element={withLayout(<Transactions />)} />
            <Route path="/app/profile" element={withLayout(<Profile />)} />
            <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" theme="light" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
